<template>
  <a-modal
    title="菜单编辑"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    okText="保存"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="早餐"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-input
            type="textarea"
            :rows="4"
            placeholder="每一项enter另起一行"
            v-decorator="['breakfast', {rules: [{required: true, message: '请输入早餐！'}]}]"/>
        </a-form-item>
        <a-form-item
          label="午餐"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-input
            type="textarea"
            :rows="4"
            placeholder="每一项enter另起一行"
            v-decorator="['lunch', {rules: [{required: true, message: '请输入中餐！'}]}]"/>
        </a-form-item>
        <a-form-item
          label="晚餐"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-input
            type="textarea"
            :rows="4"
            placeholder="每一项enter另起一行"
            v-decorator="['dinner', {rules: [{required: true, message: '请输入晚餐！'}]}]"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { saveDishes } from '@/api/manage'
import pick from 'lodash.pick'

export default {
  name: 'CreateForm',
  props: {
    info: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 22 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    show () {
      this.visible = true
      this.$nextTick(() => {
        this.loadEditInfo(this.info)
      })
    },
    handleSubmit () {
      this.confirmLoading = true
      this.form.validateFields((errors, values) => {
        if (!errors) {
          const params = {
            id: this.info.id,
            breakfast: values.breakfast,
            lunch: values.lunch,
            dinner: values.dinner,
            use_date: this.info.date,
            use_week: this.info.week
          }
          saveDishes(params).then((res) => {
            this.visible = false
            this.confirmLoading = false
            this.$emit('ok', values) // 子组件将数据带到父组件
            this.$message.success(res.msg)
          })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.visible = false
              this.confirmLoading = false
            })
        } else {
          this.confirmLoading = false
        }
      })
    },
    requestFailed (err) {
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    handleCancel () {
      this.confirmLoading = false
      this.visible = false
    },
    loadEditInfo (data) {
      new Promise((resolve) => {
        resolve()
      }).then(() => {
        const formData = pick(data, ['breakfast', 'lunch', 'dinner'])
        // console.log('formData', formData)
        this.form.setFieldsValue(formData)
      })
    }
  }
}
</script>
